module.exports = __webpack_public_path__ + "static/media/bell.f21f1db7.svg";